/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2022 Scandiweb, Inc (https://scandiweb.com)
 */

// eslint-disable-next-line import/prefer-default-export
export const SIZE_SELECTOR_POPUP_ID = 'SIZE_SELECTOR_POPUP_ID';
